module.exports = __webpack_public_path__ + "img/pomegranate.1950097d.jpg";